import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {InteractionAnswerSaveDto} from '../../models/card.model';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-card-button',
  templateUrl: './card-button.component.html',
  styleUrls: ['./card-button.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, TranslateModule],
})
export class CardButtonComponent implements OnInit {
  @Output() onSubmit = new EventEmitter();

  @Input() text: string = '';
  @Input() color: string = 'black';
  @Input() colorInverse: string = 'white';
  @Input() tightLayout: boolean = false;  // optional

  constructor() {
  }

  ngOnInit() {
  }

  onSubmitHandler() {
    this.onSubmit.emit();
  }
}
